import React from 'react'
import Main from '../layouts/Main'
import ProductsList from '../components/ProductsList'
import ProductsStatistic from '../components/ProductsStatistic'

function Products() {
    return (
        <Main>
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Products</p>
                </div>
            </div>
            <ProductsStatistic />
            <ProductsList />
        </Main>
    )
}

export default Products